<aside class="secondary-sidepanel" *ngIf="show" @openClose >
  <div class="secondary-sidepanel__inner">
    <ng-container [ngTemplateOutlet]="contentHeader"></ng-container>
  <div class="secondary-sidepanel__content scroller-right-15">
    <ng-scrollbar [style]="customStyle">
      <ng-container [ngTemplateOutlet]="content"></ng-container>
    </ng-scrollbar>
  </div>
</div>
</aside>
